import React from 'react';
import PropTypes from 'prop-types';

const CurrencySymbol = ({value}) => {
	switch (value) {
		case 'USD':
			return <span className='cur dollar'><span>$</span></span>;
		case 'EUR':
			return <span className='cur euro'><span>€</span></span>;
		case 'CNY':
			return <span className="cur cny"><span>¥</span></span>;
		case 'RUR':
			return <span className='cur ruble'><span>₽</span></span>;
		default:
			return <span className='cur'><span>{value}</span></span>;
	}
};

CurrencySymbol.propTypes = {
	value: PropTypes.string,
};

export default CurrencySymbol;
